export const getMissionHeaderTitle = (shifts, t) => {
    var _a, _b;
    const firstShiftTimestamp = (_a = shifts[0]) === null || _a === void 0 ? void 0 : _a.columns.startTime;
    const lastShiftTimestamp = (_b = shifts[shifts.length - 1]) === null || _b === void 0 ? void 0 : _b.columns.stopTime;
    const headerTitle = shifts.length === 0
        ? t('missions.noShiftsAdded')
        : `${t('date', { value: firstShiftTimestamp })} - ${t('date', { value: lastShiftTimestamp })}`;
    return headerTitle;
};
